import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ManageFieldsItemComponent } from '@app/feature/manage-fields/manage-fields-item/manage-fields-item.component'
import { ManageFieldsService } from '@app/feature/manage-fields/manage-fields.service'
import {
    FieldTypeSelectorComponent,
    FieldTypeSelectorData,
} from '@app/shared/field-type-selector/field-type-selector.component'
import { ModalContainerComponent } from '@components-library/tb-modal-manager/modal-container-component/modal-container.component'
import { Field, FieldTypes, Workspace, UpdateResponseModel } from '@core/models'
import {
    FieldTypeFacadeService,
    WorkspaceFacadeService,
    SchemaFacadeService,
} from '@core/services/store-facade'

import { TypedTemplateDirective } from '@app/shared/typed-template.directive'
import { TbButtonComponent } from '@components-library/tb-button/tb-button.component'
import {
    AccordionContentContext,
    FieldsCollectionComponent,
} from '@app/shared/fields-collection/fields-collection.component'
import { ModalLayoutComponent } from '@components-library/tb-modal-manager/modal-layout/modal-layout.component'
import { TranslocoModule } from '@jsverse/transloco'
import { AsyncPipe } from '@angular/common'
import { ModalLayoutButtonsComponent } from '@components-library/tb-modal-manager/modal-layout-buttons/modal-layout-buttons.component'

@Component({
    selector: 'app-manage-fields',
    templateUrl: './manage-fields.component.html',
    styleUrl: './manage-fields.component.sass',
    imports: [
        TranslocoModule,
        ModalLayoutComponent,
        FieldsCollectionComponent,
        TbButtonComponent,
        TypedTemplateDirective,
        AsyncPipe,
        ManageFieldsItemComponent,
        ModalLayoutButtonsComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageFieldsComponent extends ModalContainerComponent<unknown, void> {
    private readonly schemaFacadeService = inject(SchemaFacadeService)
    private readonly fieldTypeFacadeService = inject(FieldTypeFacadeService)
    private readonly workspaceFacadeService = inject(WorkspaceFacadeService)
    private readonly manageFieldsService = inject(ManageFieldsService)

    readonly excludedFieldTypes = [FieldTypes.NAME] as string[]

    fieldTypes$ = this.fieldTypeFacadeService.selectFieldTypeEntities$
    workspaces$ = this.workspaceFacadeService.selectAllWorkspaces$
    selectedSchema$ = this.schemaFacadeService.selectSelectedTableSchema$
    selectedWorkspace$ = this.workspaceFacadeService.selectSelectedWorkspace$

    contextType = {} as AccordionContentContext

    getWorkspaceForField(guid?: string, workspaces?: { [workspaceGuid: string]: Workspace }) {
        if (!workspaces || !guid) return
        return workspaces[guid]
    }

    addField(selectedWorkspace: Workspace) {
        this.modalManagerService.openDialog<FieldTypeSelectorComponent, FieldTypeSelectorData>({
            component: FieldTypeSelectorComponent,
            data: { selectedWorkspace },
        })
    }

    deleteField(field: Field) {
        this.wrapResponseObservable<UpdateResponseModel>(
            this.manageFieldsService.deleteField(field.guid),
        ).subscribe()
    }
}
